import React from 'react';
import {
  HashRouter as Router,
  Route,
  // NavLink ,
  // Link,
  // hashHistory,
  Switch,
} from 'react-router-dom'
// import Main from './components/Main.js';
import ChoosePage from './components/ChoosePage.js';
import Hdetp2DocBody from './components/Hdept2DocBody.js';
import Doc2HdeptBody from './components/Doc2HdeptBody.js';

// const baseUrl = process.env.PUBLIC_URL;

const ReactRouterV4 = () => (
  <Router>
    <div style={{ display: 'flex', flex: '1', position: 'relative'}}>
      <Switch>
        <Route exact path={'/'} component={ChoosePage} />
        <Route path={'/hdept2doc'} component={Hdetp2DocBody} />
        <Route path={'/doc2hdept'} component={Doc2HdeptBody} />
        {/*<Route path="?hdept/:team/:docno/:date" component={Timetable} />*/}

        {/*<Route path="/:hdept?/:team?/:docno?/:date?" render={({match} )=>(
               <div>
                  <h1>hdept:{match.params.hdept}</h1>
                  <h1>team:{match.params.team}</h1>
                  <h1>docno:{match.params.docno}</h1>
                  <h1>date:{match.params.date}</h1>
               </div>
            )} />*/}
      </Switch>
    </div>
  </Router>
)

// const ReaactRouterV4 = () => {
//     <BrowserRouter>
//         <Timetable />
//     </BrowserRouter>
// }

export default ReactRouterV4


// WEBPACK FOOTER //
// ./src/ReactRouterV4.js